import {
  TestCase,
  Requirement,
  SuiteTree,
  ProjectSuiteTree,
  User,
  Tag,
  FilterQuery,
  TestCaseRevision,
  CustomField,
  TestPlanConfiguration
} from "../../../services/generated-sdk/models";

export const testCaseIndexState: TestCaseIndex = {
  multiSuiteEnabled: false,
  showExecutionModal: false,
  selectedConfig: undefined,
  showQuickAddForm: false,
  count: 0,
  loading: false,
  suiteAddFormVisible: false,
  selectedSuites: [],
  testCases: [],
  searchText: "",
  pagination: {
    current: 0,
    total: 0,
    showSizeChanger: true,
    position: "bottom",
    pageSize: 10,
    pageSizeOptions: ["10", "20", "50", "100"],
    showTotal: (total: number, range: any) =>
      `${range[0]}-${range[1]} of ${total} Test Cases`,
    showQuickJumper: false,
    sorter: {
      field: "id",
      order: "ascend"
    }
  },
  diff: {
    loading: false,
    revision: false,
    prevRevision: false
  },
  executionHistory: {
    loading: false,
    history: []
  },
  changeLog: {
    loading: false,
    changes: []
  },
  requirementStatus: false,
  columnSelectorVisible: false,
  suitePanelCollapsed: false,
  requirements: { loading: false, list: [] },
  visibleColumns: [
    "id",
    "title",
    "suite",
    "priority",
    "last_run_status",
    "last_run_on",
    "run_count",
    "user_label",
    "avg_execution_time"
  ],
  filters: {
    filterType: "AND",
    selected: false,
    appliedFilters: []
  },
  suites: [],
  tags: [],
  projectRequirements: [],
  formattedSuiteTree: [],
  notLinkedSuites: [],
  selectedTestCases: [],
  members: [],
  selectedSuite: false,
  canAddTestCase: true,
  suitesLoading: false,
  selectedTestCase: false,
  selectedCaseIndex: false,
  userExpandedSuite: null,
  testCasePanelActiveTab: "comments",
  projectId: 0,
  addingSuite: false,
  showSuiteLayoutOptions: false,
  showImmediateChildren: false,
  displayFilterBar: false,
  isSorting: false,
  displayTestCasesInTree: false,
  draggedTestCase: null,
  showSortLabel: true,
  showFullScreenButton: true,
  showCaseSelector: true,
  showSuitePanelSettings: true,
  isTestCaseSelectionMode: false,
  layoutPosition: "relative",
  showExecButton: true,
  customFields: [],
  automationProcessing: false,
  selectTestCases: () => {},
  [Symbol.iterator]: function*() {
    yield 1;
  }
};

interface EditableSuite extends SuiteTree {
  // id: number | string,
  parentId: number;
  editable: boolean;
}

export interface TestCaseIndex {
  testCases: TestCase[];
  showExecutionModal: boolean;
  isTestCaseSelectionMode: boolean;
  showExecButton: boolean;
  showFullScreenButton: boolean;
  showQuickAddForm: boolean;
  showCaseSelector: boolean;
  count: number;
  loading: boolean;
  selectedConfig?: TestPlanConfiguration;
  layoutPosition:
    | "-moz-initial"
    | "inherit"
    | "initial"
    | "revert"
    | "unset"
    | "fixed"
    | "-webkit-sticky"
    | "absolute"
    | "relative"
    | "static"
    | "sticky"
    | undefined;
  suiteAddFormVisible: boolean;
  selectedSuites: Array<string>;
  userExpandedSuite: number | null;
  columnSelectorVisible: boolean;
  suitePanelCollapsed: boolean;
  displayTestCasesInTree: boolean;
  addingSuite: boolean;
  pagination: Pagination;
  diff: Diff;
  executionHistory: ExecutionHistory;
  changeLog: ChangeLog;
  searchText: string;
  displayFilterBar: Boolean;
  requirementStatus: boolean;
  requirements: Requirements;
  visibleColumns: Array<string>;
  suites: Array<EditableSuite>;
  suitesLoading: boolean;
  canAddTestCase: boolean;
  selectedSuite: object | false;
  selectedTestCase: TestCase | false;
  selectedCaseIndex: number | boolean;
  testCasePanelActiveTab: string;
  projectId: number;
  showSuiteLayoutOptions: boolean;
  showSuitePanelSettings: boolean;
  showImmediateChildren: boolean;
  isSorting: boolean;
  draggedTestCase: TestCase | null;
  filters: Filters;
  notLinkedSuites: ProjectSuiteTree[];
  projectRequirements: Requirement[];
  formattedSuiteTree: Array<any>;
  tags: Tag[];
  members: User[];
  customFields: CustomField[];
  selectedTestCases: number[];
  showSortLabel: Boolean;
  selectTestCases: (param?: any) => void;
  [Symbol.iterator]();
  multiSuiteEnabled: boolean;
  automationProcessing: boolean;
}

export interface Diff {
  loading: boolean;
  revision: TestCaseRevision | false;
  prevRevision: TestCaseRevision | false;
}

export interface ExecutionHistory {
  loading: boolean;
  history: Array<any>;
}

export interface ChangeLog {
  loading: boolean;
  changes: Array<any>;
}
export interface Requirements {
  loading: boolean;
  list: Array<Requirement>;
}

export interface Filters {
  appliedFilters: Array<FilterQuery>;
  selected: boolean;
  filterType: string;
  selectedFilter?: number | false;
}

export interface Pagination {
  current: number;
  total: number;
  showSizeChanger: boolean;
  position: "top" | "bottom" | "both";
  pageSize: number;
  pageSizeOptions: ["10", "20", "50", "100"];
  showTotal: (total: number, range: any) => string;
  showQuickJumper: boolean;
  sorter: {
    field: string;
    order: "ascend" | "descend";
  };
}
